import {ContactPermissionStatus} from './influencer';

export const enum MessageType {
  InComming = 1,
  OutGoing = 2,
  Invitation = 3
}

export const enum ShortMessageStatus {
  Normal = 0,
  Warning = 1
}

export class ContactPermission {
  id: number;
  status: string;
  influencerId: number;
  influencerName: string;
  advertiserId: number;
  advertiserName: string;
  agencyName: string;
  expiresAt: number;
}

export const enum ContactPermissionMessageType {
  accepted = 'ACCEPTED_PERMISSION',
  requested = 'REQUESTED_PERMISSION',
  rejected = 'REJECTED_PERMISSION',
  normal = 'NORMAL'
}

export interface Conversation {
  id: number;
  createdAt: Date;
  lastUpdated: Date;
  messages: Message[];
  name: string;
  participants: Participant[];
  status: ShortMessageStatus;
  isHidden: boolean;
  isJoined: boolean;
  isSelected: boolean;
  permission: ContactPermissionStatus;
}

export interface Participant {
  id: number;
  name: string;
  company: any;
  influencer: any;
  lastSeenMessage: any;
  user: any;
}

export interface Message {
  id: number;
  conservationId: number;
  sender: Participant;
  content: string;
  type: MessageType;
  recipientName: string;
  sentTime: string;
  messageType?: string;
  date?: string;
  // using for campaign
  campaignId?: number;
  campaignInfluencerId?: number;
  status?: string;
  activityAuthor?: string;
  isSending?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/inbox.ts